import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'includes',
})
export class IncludesPipe implements PipeTransform {
  transform(arr: (number | string)[], value: number | string): boolean {
    return arr.includes(value);
  }
}
